/* eslint-disable import/prefer-default-export */
const S3_BASE_URL = 'https://public-files.efexpay.com';

export const PUBLIC_URLS = {
  S3: {
    BASE_URL: S3_BASE_URL,
    ONBOARDING: {
      BUSSINES_MODEL_EN: `${S3_BASE_URL}/onboarding/Business+Model+Structure.docx`,
      BUSSINES_MODEL_ES: `${S3_BASE_URL}/onboarding/Estructura+Modelo+de+Negocio.docx`,
    },
  },
  CURP_HELPER_URL: 'https://www.gob.mx/curp/',
};
